import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import * as moment from "moment";
import { namespace } from 'vuex-class';
import { TICKET_MODULE_NAMESPACE, TICKET_GET_APPOINTMENTS } from '../../../../store/ticket';
import { ITicketListingViewModel, TicketInterventionReport, ITicketInterventionReport } from '../../../../models/ticket';
import * as _ from "lodash";
const TicketStore = namespace(TICKET_MODULE_NAMESPACE)

@Component
class Container extends Vue {

  dtCurrentStep: number;
  newEmail: any;
  errorMessage: string;
  emails: any;

  @Prop({ type: Object, required: true })
  value: ITicketInterventionReport;


  get reserve(): string {
    return this.value.reserve;
  }
  set reserve(value: string) {
    this.$emit('input', { ...this.value, reserve: value })
  }

  get fkAppointment(): number {
    return this.value.fk_appointment;
  }
  set fkAppointment(value: number) {
    this.$emit('input', { ...this.value, fk_appointment: value })
  }
  get signature(): string {
    return this.value.signature;
  }
  set signature(value: string) {
    this.$emit('input', { ...this.value, signature: value })
  }
  get startDate(): string {
    return this.value.start_date;
  }
  set startDate(value: string) {
    this.$emit('input', { ...this.value, start_date: value })
  }
  get endDate(): string {
    return this.value.end_date;
  }
  set endDate(value: string) {
    this.$emit('input', { ...this.value, end_date: value })
  }


  get numberKm(): number {
    return this.value.number_km;
  }
  set numberKm(value: number) {
    this.$emit('input', { ...this.value, number_km: value })
  }
  get coEmails(): any {
    return this.value.share_email;
  }
  set coEmails(value: any) {
    this.$emit('input', { ...this.value, share_email: value })
  }
  /**
   *
   */
  constructor() {
    super();
    this.dtCurrentStep = 1;
    this.emails = [];
    this.errorMessage = ''
    this.newEmail = ''
  }

  @TicketStore.Getter appointments: { start_date: string; end_date: string; name: string; id: number }[]
  @TicketStore.Action(TICKET_GET_APPOINTMENTS)
  storeGetAppointmentsByTicketId: (ticketId: string) => Promise<any>
//...require('../../../../locales/generic-labels').default,
  get lblSetting() {
    return {
      ...require('@/locales/ticket').default,
      ...require('@/locales/generic-labels').default
    }
  }
  get textConfigs() {
    return require("@/assets/json-resources/text-field-configs.json")
  }

  get coDates() {
    return {
      startDate: this.startDate,
      endDate: this.endDate
    }
  }
  set coDates(dates: { startDate: string | Date | moment.Moment, endDate: string | Date | moment.Moment }) {
    const sD = moment(dates.startDate).format("YYYY-MM-DDTHH:mm");
    const eD = moment(dates.endDate).format("YYYY-MM-DDTHH:mm");
    this.$emit('input', {
      ...this.value,
      start_date: dates.startDate.toString(),
      end_date: dates.endDate.toString()
    })
  }

  get coAppointments() {
    return this.appointments;
  }

  mounted() {
    this.storeGetAppointmentsByTicketId(this.$route.params.id)
      .then(res => {if (res.length > 0) this.handleChangeAppointment(res[0].id)})
  }

  handleChangeAppointment(event) {
    const appointment = this.coAppointments.find(x => x.id === event);
    if (appointment) {
      this.$emit('input', {
        ...this.value,
        fk_appointment: event,
        start_date: appointment.start_date.substring(0, 16),
        end_date: appointment.end_date.substring(0, 16)
      })
    }
  }

  handleClearSignature() {
    (this.$refs.signaturePad as any).clearSignature();
    this.signature = "";
  }
  handleUndo() {
    (this.$refs.signaturePad as any).undoSignature();
    setTimeout(this.onEnd, 200)
  }
  onEnd() {
    const { data, isEmpty } = (this.$refs.signaturePad as any).saveSignature()
    if (!isEmpty) {
      this.signature = data;
    }
  }

  addEmail() {
    let value = this.newEmail && this.newEmail.trim();
    let mailFormat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/;
    if (!value) {
      return;
    }
    if (value.match(mailFormat)) {
      this.emails.push(this.newEmail);
      this.newEmail = '';
      this.errorMessage = '';
    } else {
      this.errorMessage  = this.$t(this.lblSetting.invalidEmail) as string;
      this.newEmail = '';
    }
    this.value.share_email = this.emails
  }
  removeEmail(index) {
    this.emails.splice(index, 1);
  }
  handleNumberKm(value: string | number ){
    this.numberKm = typeof value === 'number' ? value : parseInt(value)
  }

}

export default Container;



// WEBPACK FOOTER //
// ./src/containers/ticket/components/ticket-modal-generate-intervention-report/index.ts